export const TEXT_MESSAGE_DIRECTIONS = {
  inbound: "inbound",
  outbound: "outbound",
} as const;

export const TEXT_MESSAGE_STATES = {
  created: "created",
  queued: "queued",
  sent: "sent",
  failed: "failed",
  delivered: "delivered",
  undelivered: "undelivered",
  read: "read",
} as const;

export const CONVERSATION_TYPES = {
  conversation: "conversation",
  manual: "manual",
  outbound: "outbound",
  opted_out: "opted_out",
} as const;

export const TEXT_MESSAGE_TAB_LABELS = {
  [CONVERSATION_TYPES.conversation]: "Conversations",
  [CONVERSATION_TYPES.manual]: "Manual",
  [CONVERSATION_TYPES.outbound]: "Outbound",
  [CONVERSATION_TYPES.opted_out]: "Opted out",
} as const;
